import { Card, CardBody, Col, Row } from "reactstrap";
import { CustomModalsTitle } from "../../../../constants";
import { CustomModalSubTitle } from "../../../../data/uiKits/Modal";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import CustomModal1 from "./customModal1";
import CustomModal2 from "./CustomModal2";
import CustomModal3 from "./customModal3";

const CustomModals = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={CustomModalsTitle} span={CustomModalSubTitle} />
        <CardBody>
          <Row className="g-3">
            <CustomModal1 />
            <CustomModal2 />
            <CustomModal3 />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default CustomModals;
